<template>
  <div>
    <h2 class="small-title">Votre consultant</h2>

    <div class="card mb-3">
      <div class="card-body">
        <div class="row">

          <div class="col-4">
            <div class="position-relative">
              <img v-if="consultant" :src="settings.backendMediaUrl+consultant.avatar"
                   class="img-fluid rounded-md sh-10" alt="thumb">
            </div>
          </div>
          <div class="col-8">
            <div class="h6 mb-2" v-if="consultant">
              {{ consultant.firstname }}
            </div>
            <div class="text-muted">
              <a :href="'tel:'+consultant.phone">
                <i data-acorn-icon="phone" class="icon_" data-acorn-size="15" data-acorn-stroke-width="1.5"></i>
                <span v-if="consultant">&nbsp;{{ consultant.phone }}</span>
              </a>
            </div>
            <div class="text-muted">
              <a :href="'mailto:'+consultant.email">
                <i data-acorn-icon="at-sign" class="icon_" data-acorn-size="15" data-acorn-stroke-width="1.5"></i>
                <span v-if="consultant">&nbsp;{{ consultant.email }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import settings from '@/settings.coffee'

export default {
  props: {
    consultant: Object
  },
  computed: {
    settings() {
      return settings
    }
  },
  mounted() {
    setTimeout(() => {
      new AcornIcons().replace()
    }, 200)
  }
}
</script>
